import React, { useState, useEffect } from "react";
import useActiveTabs from "../../../../hooks/active-tabs";
import RightSidebar from "../../../styled-components/right-sidebar/right-sidebar";
import FormHeader from "../../../styled-components/form-header/form-header";
import StaticReturnRate from "./static-return-rate/static-return-rate";
import ProfessionalPredictions from "./professional-prediction/professional-predictions";
import UserDefined from "./user-defined/user-defined";
import MonteCarlo from "./monte-carlo/monte-carlo";
import NewLoader from "../../../styled-components/loader/NewLoader";
import { useHistory } from "react-router-dom";
import { useSelector } from "react-redux";

import TAX_AND_INFLATION_API from "../../../../apis/tax_and_inflation.api";
function TaxInflationMain() {
  const [activeTabData, setActiveTabData] = useState({
    name: "staticReturnRate",
    title: "Static Rate of Return",
    isMulti: false,
    component: StaticReturnRate,
  });
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [rateOfReturnData, setRateOfReturnData] = useState(null);
  const ActiveComponent = activeTabData.component;

  const [rightToggleClass, setRightToggleClass] = useState(false);
  const staticRateofReturnValue = useSelector(
    (state) => state.rootReducer.inventory.selectedStaticRateofReturn
  );


  const ratesOfReturnData = {
    staticReturnRate: {
      name: "staticReturnRate",
      title: "Static Rate of Return",
      isMulti: false,
      component: StaticReturnRate,
      data: [
        {
          Static: rateOfReturnData && rateOfReturnData.staticPercentage
              ? rateOfReturnData.staticPercentage
              : "",
        },
      ],
    },
    // professionalPredictions: {
    //   name: "professionalPredictions",
    //   title: "Professional Predictions",
    //   isMulti: false,
    //   component: ProfessionalPredictions,
    //   data: [
    //     {
    //       "Professional Predictions": "William Forsyth Sharpe",
    //       "Prediction File": "abc.doc",
    //     },
    //   ],
    // },
    userDefined: {
      name: "userDefined",
      title: "User Defined",
      component: UserDefined,
      isMulti: true,
      data: [],
    },
    // monteCarlo: {
    //   name: "monteCarlo",
    //   title: "Monte Carlo",
    //   isMulti: true,
    //   component: MonteCarlo,
    //   data: [
    //     {
    //       Description: "sample",
    //       "How Many Years": "15",
    //       "High Band": "8",
    //       "Low Band": "6",
    //       "Expected Average": "80",
    //       "Start Year": "2019",
    //       Average: "85",
    //     },
    //     {
    //       Description: "sample",
    //       "How Many Years": "15",
    //       "High Band": "9",
    //       "Low Band": "6",
    //       "Expected Average": "85",
    //       "Start Year": "2019",
    //       Average: "90",
    //     },
    //   ],
    // },
  };

  const [allFormsData, setAllFormsData] = useState(ratesOfReturnData);

  const tabsArray = Object.values(ratesOfReturnData);
  const [activeTabsArray, setActiveTabsArray] = useState(["staticReturnRate"]);

  //  pass all tabs array and selected tab name to useActiveTabs hook
  //  useActiveTabs Hook will return all previous tabs with selected tab
  const handleActiveTabsArray = (name) => {
    const activeTabs = useActiveTabs(tabsArray, name);

    setActiveTabsArray([...activeTabs]);
  };

  const nextForm = (nextFormData) => {
    setActiveTabData(nextFormData);

    const activeTabs = useActiveTabs(tabsArray, nextFormData.name);

    setActiveTabsArray([...activeTabs]);
  };
  const preForm = (previousFormData) => {
    setActiveTabData(previousFormData);

    const activeTabs = useActiveTabs(tabsArray, previousFormData.name);

    setActiveTabsArray([...activeTabs]);
  };

  // pass all form data of one component and update in main object (allFormsData)
  const handleRatesOfReturnObject = async (pageData) => {
    setAllFormsData((formData) => {
      return {
        ...formData,
        [activeTabData.name]: {
          ...formData[activeTabData.name],
          data: activeTabData.isMulti ? pageData : [pageData],
        },
      };
    });
    if (activeTabData.name === "userDefined") {
      let payload = {
        staticPercentage:
          allFormsData &&
          allFormsData.staticReturnRate &&
          +allFormsData.staticReturnRate.data[0]["Static"],

        // generalInflationRate: pageData && +pageData["General Inflation Rate"],
        // medicalInflationRate: pageData && +pageData["Medical Inflation Rate"],
        // educationInflationRate:
        //   pageData && +pageData["Education Inflation Rate"],
        // luxuryInflationRate: pageData && +pageData["Luxury Inflation Rate"],
        // housingInflationRate: pageData && +pageData["Housing Infaltion Rate"],
      };
      try {
        setLoading(true);
        if (rateOfReturnData && rateOfReturnData) {
          payload.id = rateOfReturnData && rateOfReturnData.id;
          let res = await TAX_AND_INFLATION_API.updateRatesofReturn(payload);
          if (res && res.status === 200) {
            history.push("/rates_of_return");
          }
        } else {
          let res = await TAX_AND_INFLATION_API.createRatesofReturn(payload);
          if (res && res.status === 200) {
            history.push("/rates_of_return");
          }
        }
        setLoading(false);
      } catch (error) {
        setLoading(false);
        console.log("error while creating Rate of Retrun", error);
      }
    }
  };
  const getRateofReturnDetails = async () => {
    try {
      setLoading(true);
      let data = await TAX_AND_INFLATION_API.getRatesofReturn();
      if (data && data.data) {
        setRateOfReturnData(data.data);
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log("error while fetching Rate of Retrun Details", error);
    }
  };
  useEffect(() => {
    getRateofReturnDetails();
  }, []);

  return (
    <div style={{ margin: "1rem" }}>
      <div
        style={{
          backgroundColor: "white",
          borderRadius: "1rem",
          paddingBottom: "40px",
        }}
        className={
          rightToggleClass
            ? "form-page-container-wrap right-side--opend"
            : "form-page-container-wrap right-side--collapsed"
        }
      >
        <div style={{ paddingRight: rightToggleClass ? "400px" : "0px" }}>
          <FormHeader
            headerData={ratesOfReturnData}
            activeTabData={activeTabData}
            setActiveTabData={setActiveTabData}
            activeTabsArray={activeTabsArray}
            handleActiveTabsArray={handleActiveTabsArray}
            handleTabClick={(tabName) => {
              const selectedTab =
                tabsArray && tabsArray.find((tab) => tab.name === tabName);
              console.log("tabName", tabName, selectedTab, tabsArray);
              if (selectedTab) {
                setActiveTabData(selectedTab);
                handleActiveTabsArray(tabName);
              }
            }}
          />
        </div>
        <div style={{ paddingRight: rightToggleClass ? "400px" : "0px" }}>
          <ActiveComponent
            handleRatesOfReturnObject={handleRatesOfReturnObject}
            data={allFormsData}
            nextForm={nextForm}
            rateOfReturnData={rateOfReturnData}
            preForm={preForm}
            activeTabData={activeTabData}
          />
        </div>
        <NewLoader isLoading={loading} />
      </div>
    </div>
  );
}

export default TaxInflationMain;
